module.exports = __webpack_public_path__ + "img/MEDIA106.dbe73e14.jpg";